import React, { useState,useEffect } from "react";
import ModalSearch from "../../ModalSearch";
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import { useGetProfessionsMutation, useUpdateProfileMutation } from "../../../store/appSlice";
import { useAppDispatch, useAppSelector } from "../../../store/store";
import {isNil} from "lodash";
import { setProfileData } from "../../../reducers/userReducer";



function CandidateOverviewSpecialityOnly() {
  const {user, profileData } = useAppSelector((state) => state["user"]);
  const [specialityData,setSpecialityData]=useState(profileData?.professions??[]) 
  const [specialitiesModal,setSpecialitiesModal]=useState(false)
  const [onFirstRender,setFirstRender]=useState(true)
  const [allSpeciality,setAllSpeciality]=useState([])

  const [getProfessions, { data: professionsData }] =
  useGetProfessionsMutation();
  const [updateProfile] = useUpdateProfileMutation();
  const dispatch=useAppDispatch()

 

  useEffect(()=>{ 
    onProfileDataChange()
  },[profileData])


const onProfileDataChange=()=>{

  if(!isNil(profileData) ){
    setFirstRender(false)
    getAllProfessions()
  }

  if(!isNil(profileData)){
    setSpecialityData(profileData?.professions??[])
  }

}


  const onSave=(selectedData,tempDataForReducer)=>{


let dataForReducer=tempDataForReducer.map((item)=>{
  let obj={
    id:item.id,
    professionName:item.name
  }
  return obj
})

    const payload = {
      professionIds:selectedData,
      param: user?.id,
    };

    updateProfile(payload)
      .unwrap()
      .then ((incomingData) => { 
         dispatch(setProfileData({professions:[...dataForReducer]}));
      })
  }

const getAllProfessions=()=>{
  
  getProfessions(profileData?.industries[0]?.id??"")
    .unwrap()
    .then((incomingData) => {
      
      const newIncomingData = incomingData.map(({
        professionName: name,
        ...rest
      }) => ({
        name,
        ...rest
      }));
      setAllSpeciality(newIncomingData)
    })
    .catch((err) => {
      console.log(err);
    });
}


  const onEditSpecialities=()=>{
    setSpecialitiesModal(true) 
    }


  return (
    <div className='container_sections_wrapper'>
      <div className="candidate-about__r6-skills-only" style={{display:'flex',flexDirection:'row'}}>
        <div>
        { <h3 style={{fontWeight:700,fontSize:'17px'}}>Speciality</h3>}

        {specialityData?.length > 0 && (
          <div className="co-skills-only__skills-cont">
            {specialityData.map((speciality) => {
              return (
                <div key={speciality.id} className="coso-skills-cont__ind-skill-div">
                  <h4>{speciality.professionName}</h4>
                </div>
              );
            })}
          </div>
        )}

</div> 
{/* <AddCircleOutlineIcon fontSize="large" style={{marginTop:'5px'}}/> */}
      </div>
      {specialitiesModal && (<ModalSearch subText={"Your speciality"} onDataSave={onSave} dataList={allSpeciality} selectedData={profileData.professions} isVisible={specialitiesModal} selectionLimit={3} onClose={()=>setSpecialitiesModal(!specialitiesModal)}/>) }
     <div onClick={ onEditSpecialities} className="add_icon"> <AddCircleOutlineIcon fontSize="large" style={{marginTop:'5px'}}/></div>

    </div>
  );
}

export default CandidateOverviewSpecialityOnly;
